import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const notificaciones = {
	state: {
		notificaciones : ''
	},
	getters: {
		getNotificaciones : state => state.notificaciones,   
	}, 
	actions: {
		requestNotificaciones : function({commit,getters,dispatch}){

			let url = (getters.isEmpresa) ? '/api/Empresa/dameNotificaciones' : '/api/Alumno/dameNotificaciones';

			return new Promise((resolve, reject) => {
				axios.get(url).then(response => {
					if(response.data.status == 0){
						commit('setNotificaciones', response.data.datos)
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		marcarNotificacionLeida : function({commit,getters,dispatch}, id){
			let url = (getters.isEmpresa) ? '/api/Empresa/marcarNotificacionLeida' : '/api/Alumno/marcarNotificacionLeida';
			return new Promise((resolve, reject) => {
				axios.post(url,{"id":id}).then(response => {
					if(response.data.status == 0){
						resolve(true);
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		eliminaNotificacion : function({commit,getters,dispatch}, id){
			let url = (getters.isEmpresa) ? '/api/Empresa/eliminaNotificacion' : '/api/Alumno/eliminaNotificacion';
			return new Promise((resolve, reject) => {
				axios.post(url,{"id":id}).then(response => {
					if(response.data.status == 0){
						commit('setEraseNotificacion',id);
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		marcarNotificacionesSinEnlaceLeidas : function({commit,getters,dispatch}){
			return new Promise((resolve, reject) => {
				let url = (getters.isEmpresa) ? '/api/Empresa/marcarNotificacionesSinEnlaceLeidas' : '/api/Alumno/marcarNotificacionesSinEnlaceLeidas';
				axios.post(url).then(response => {
					if(response.data.status == 0){
						resolve(true);
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		borrarTodas : function({commit,getters,dispatch}){
			return new Promise((resolve, reject) => {
				let url = (getters.isEmpresa) ? '/api/Empresa/eliminaNotificaciones' : '/api/Alumno/eliminaNotificaciones';
				axios.post(url).then(response => {
					if(response.data.status == 0){
						commit('eraseAllNotificaciones')
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

	},
	mutations: {
		setNotificaciones : function(state,data){
			state.notificaciones = data;
		},
		setEraseNotificacion : function(state,id){
			state.notificaciones = state.notificaciones.filter(e => e.idNotificacion != id);	
		},
		eraseAllNotificaciones : function(state,id){
			state.notificaciones = []	
		}
	}
}

export default notificaciones;



// WEBPACK FOOTER //
// ./submodules/dotia-base-fp/src/store/notificaciones.js